import type { TrackingLink, ThemeClasses } from "../types";
import { TrackingLinkGridCard } from "./TrackingLinkGridCard";
import { TrackingLinkListRow } from "./TrackingLinkListRow";
import { DENSE_LIST } from "../../../../shared";

interface TrackingLinkListProps {
  trackingLinks: TrackingLink[];
  loading: boolean;
  selectedView: "grid" | "list";
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  onEdit: (trackingLink: TrackingLink) => void;
  onDelete: (trackingLink: TrackingLink) => void;
  onCopy: (trackingLink: TrackingLink) => void;
  onActivate: (trackingLink: TrackingLink) => void;
  onExtend: (trackingLink: TrackingLink) => void;
  onDetails: (trackingLink: TrackingLink) => void;
  onRemove?: (trackingLink: TrackingLink) => void;
  loadingDetails?: boolean;
  loadingActions?: Record<string, boolean>;
}

export function TrackingLinkList({
  trackingLinks,
  loading,
  selectedView,
  themeClasses,
  isDarkMode,
  onEdit,
  onDelete,
  onCopy,
  onActivate,
  onExtend,
  onDetails,
  onRemove,
  loadingDetails,
  loadingActions,
}: TrackingLinkListProps) {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (trackingLinks.length === 0) {
    return (
      <div
        className={`text-center h-full text-lg flex flex-col items-center justify-center ${themeClasses.textSecondary}`}
      >
        <i className="ri-link text-6xl mb-4 opacity-30"></i>
        <p>No hay links de seguimiento</p>
      </div>
    );
  }

  if (selectedView === "grid") {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 sm:gap-6">
        {trackingLinks.map((trackingLink) => (
          <TrackingLinkGridCard
            key={trackingLink.id}
            trackingLink={trackingLink}
            themeClasses={themeClasses}
            isDarkMode={isDarkMode}
            onEdit={onEdit}
            onDelete={onDelete}
            onCopy={onCopy}
            onActivate={onActivate}
            onExtend={onExtend}
            onDetails={onDetails}
            onRemove={onRemove}
            loadingDetails={loadingDetails}
            loadingActions={loadingActions}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {trackingLinks.map((trackingLink) => (
        <TrackingLinkListRow
          key={trackingLink.id}
          trackingLink={trackingLink}
          themeClasses={themeClasses}
          onEdit={onEdit}
          onDelete={onDelete}
          onCopy={onCopy}
          onActivate={onActivate}
        />
      ))}
    </div>
  );
}
